module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step == 1) ? _c('PlanDetail', {
    on: {
      "nexStep": _vm.nexStep
    }
  }) : (_vm.step == 2) ? _c('Payment', {
    on: {
      "nexStep": _vm.nexStep,
      "previousStep": _vm.previousStep
    }
  }) : _c('Success')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f248661c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/plan_detail.vue
// module id = 1868
// module chunks = 180